import { render, staticRenderFns } from "./comTerm1.vue?vue&type=template&id=207587ca&scoped=true&"
import script from "./comTerm1.vue?vue&type=script&lang=js&"
export * from "./comTerm1.vue?vue&type=script&lang=js&"
import style0 from "./comTerm1.vue?vue&type=style&index=0&id=207587ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207587ca",
  null
  
)

export default component.exports